!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("@tinacms/react-modals"), require("@tinacms/core"), require("@tinacms/react-forms"), require("@tinacms/react-screens"), require("@tinacms/fields"), require("@tinacms/form-builder"), require("@tinacms/react-core"), require("react"), require("@tinacms/icons"), require("@tinacms/styles"), require("@tinacms/react-sidebar"), require("@tinacms/react-toolbar"), require("@tinacms/alerts"), require("styled-components"), require("path"), require("react-dropzone"), require("@tinacms/react-alerts"), require("@tinacms/forms")) : "function" == typeof define && define.amd ? define(["exports", "@tinacms/react-modals", "@tinacms/core", "@tinacms/react-forms", "@tinacms/react-screens", "@tinacms/fields", "@tinacms/form-builder", "@tinacms/react-core", "react", "@tinacms/icons", "@tinacms/styles", "@tinacms/react-sidebar", "@tinacms/react-toolbar", "@tinacms/alerts", "styled-components", "path", "react-dropzone", "@tinacms/react-alerts", "@tinacms/forms"], e) : e((n = n || self).tinacms = {}, n.reactModals, n.core, n.reactForms, n.reactScreens, n.fields, n.formBuilder, n.reactCore, n.React, n.icons, n.styles, n.reactSidebar, n.reactToolbar, n.alerts, n.styled, n.path, n.reactDropzone, n.reactAlerts, n.forms);
}(this, function (e, s, n, r, t, i, a, d, _, o, u, f, m, l, c, q, D, p, g) {
  "use strict";

  var N = "default" in _ ? _.default : _,
      h = "default" in c ? c.default : c;

  function A() {
    return d.useCMS();
  }

  q = q && q.hasOwnProperty("default") ? q.default : q;

  var y = function y(n, e, t) {
    this.form = n, this.__type = "screen", this.name = n.label, this.Icon = e || o.SettingsIcon, this.layout = t || "popup", this.Component = function () {
      return _.createElement(r.FormView, {
        activeForm: n
      });
    };
  };

  var _b = function b(n, e) {
    return (_b = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (n, e) {
      n.__proto__ = e;
    } || function (n, e) {
      for (var t in e) {
        e.hasOwnProperty(t) && (n[t] = e[t]);
      }
    })(n, e);
  };

  var _T = function T() {
    return (_T = Object.assign || function (n) {
      for (var e, t = 1, r = arguments.length; t < r; t++) {
        for (var i in e = arguments[t]) {
          Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
        }
      }

      return n;
    }).apply(this, arguments);
  };

  function L(n, e) {
    var t = {};

    for (var r in n) {
      Object.prototype.hasOwnProperty.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
    }

    if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
      var i = 0;

      for (r = Object.getOwnPropertySymbols(n); i < r.length; i++) {
        e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(n, r[i]) && (t[r[i]] = n[r[i]]);
      }
    }

    return t;
  }

  function B(t, r) {
    var i,
        a,
        o,
        n,
        l = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
    return n = {
      next: e(0),
      throw: e(1),
      return: e(2)
    }, "function" == typeof Symbol && (n[Symbol.iterator] = function () {
      return this;
    }), n;

    function e(e) {
      return function (n) {
        return function (e) {
          if (i) throw new TypeError("Generator is already executing.");

          for (; l;) {
            try {
              if (i = 1, a && (o = 2 & e[0] ? a.return : e[0] ? a.throw || ((o = a.return) && o.call(a), 0) : a.next) && !(o = o.call(a, e[1])).done) return o;

              switch (a = 0, o && (e = [2 & e[0], o.value]), e[0]) {
                case 0:
                case 1:
                  o = e;
                  break;

                case 4:
                  return l.label++, {
                    value: e[1],
                    done: !1
                  };

                case 5:
                  l.label++, a = e[1], e = [0];
                  continue;

                case 7:
                  e = l.ops.pop(), l.trys.pop();
                  continue;

                default:
                  if (!(o = 0 < (o = l.trys).length && o[o.length - 1]) && (6 === e[0] || 2 === e[0])) {
                    l = 0;
                    continue;
                  }

                  if (3 === e[0] && (!o || e[1] > o[0] && e[1] < o[3])) {
                    l.label = e[1];
                    break;
                  }

                  if (6 === e[0] && l.label < o[1]) {
                    l.label = o[1], o = e;
                    break;
                  }

                  if (o && l.label < o[2]) {
                    l.label = o[2], l.ops.push(e);
                    break;
                  }

                  o[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }

              e = r.call(t, l);
            } catch (n) {
              e = [6, n], a = 0;
            } finally {
              i = o = 0;
            }
          }

          if (5 & e[0]) throw e[1];
          return {
            value: e[0] ? e[1] : void 0,
            done: !0
          };
        }([e, n]);
      };
    }
  }

  function v(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: e
    }) : n.raw = e, n;
  }

  var w,
      x = {
    __type: "field",
    name: "date",
    Component: j("Date", "https://github.com/tinacms/tinacms/pull/1281")
  },
      E = {
    __type: "field",
    name: "markdown",
    Component: j("Markdown", "https://github.com/tinacms/tinacms/pull/1134")
  },
      P = {
    __type: "field",
    name: "html",
    Component: j("HTML", "https://github.com/tinacms/tinacms/pull/1134")
  },
      C = h.p.withConfig({
    displayName: "PlaceholderParagraph",
    componentId: "sc-jrtkjm"
  })(w = w || v(["\n  white-space: normal;\n  font-size: var(--tina-font-size-2);\n  margin: 8px 0 0 0;\n\n  a {\n    color: var(--tina-color-primary);\n  }\n"], ["\n  white-space: normal;\n  font-size: var(--tina-font-size-2);\n  margin: 8px 0 0 0;\n\n  a {\n    color: var(--tina-color-primary);\n  }\n"]));

  function j(e, t) {
    return function (n) {
      return N.createElement(i.FieldMeta, {
        name: n.input.name,
        label: "Deprecated: " + e + " Field"
      }, N.createElement(C, null, "In order to help improve bundle sizes the ", e, " Field has been removed from the set of default fields."), N.createElement(C, null, "See the docs to learn how to", " ", N.createElement("a", {
        href: "https://tinacms.org/docs/cms/plugins#adding-plugins",
        target: "_blank",
        rel: "noreferrer noopener"
      }, "add the ", e, " plugin"), " ", "to your CMS."), N.createElement(C, null, "Visit the", " ", N.createElement("a", {
        href: t,
        target: "_blank",
        rel: "noreferrer noopener"
      }, "Pull Request"), " ", "to learn more about why this change was made."));
    };
  }

  function S() {
    var n = A(),
        e = _.useState(),
        t = e[0],
        r = e[1];

    if (_.useEffect(function () {
      return n.events.subscribe("media:open", function (n) {
        n.type;
        var e = L(n, ["type"]);
        r(e);
      });
    }, []), !t) return null;

    function i() {
      return r(void 0);
    }

    return N.createElement(s.Modal, null, N.createElement(s.FullscreenModal, null, N.createElement(s.ModalHeader, {
      close: i
    }, "Media Manager"), N.createElement(s.ModalBody, null, N.createElement(M, _T({}, t, {
      close: i
    })))));
  }

  function M(n) {
    var t = this,
        e = n.allowDelete,
        r = n.onSelect,
        i = n.close,
        a = L(n, ["allowDelete", "onSelect", "close"]),
        o = A(),
        l = _.useState(function () {
      return o.media.isConfigured ? "loading" : "not-configured";
    }),
        c = l[0],
        s = l[1],
        d = _.useState(a.directory),
        u = d[0],
        f = d[1],
        m = _.useState(0),
        p = m[0],
        g = m[1],
        h = _.useState(a.limit || 50)[0],
        y = _.useState({
      limit: h,
      offset: p,
      items: [],
      totalCount: 0
    }),
        b = y[0],
        v = y[1];

    _.useEffect(function () {
      function n() {
        s("loading"), o.media.list({
          offset: p,
          limit: h,
          directory: u
        }).then(function (n) {
          v(n), s("loaded");
        }).catch(function (n) {
          console.error(n), s("error");
        });
      }

      return n(), o.events.subscribe(["media:upload:success", "media:delete:success"], n);
    }, [p, h, u]);

    function w(n) {
      "dir" === n.type && (f(q.join(n.directory, n.filename)), g(0));
    }

    var x, E;
    e && (x = function x(n) {
      confirm("Are you sure you want to delete this file?") && o.media.delete(n);
    }), r && (E = function E(n) {
      r(n), i && i();
    });

    var P = _.useState(!1),
        C = P[0],
        j = P[1],
        S = D.useDropzone({
      accept: "image/*",
      onDrop: function onDrop(n) {
        var e = n[0];
        return function (a, o, l, c) {
          return new (l = l || Promise)(function (n, e) {
            function t(n) {
              try {
                i(c.next(n));
              } catch (n) {
                e(n);
              }
            }

            function r(n) {
              try {
                i(c.throw(n));
              } catch (n) {
                e(n);
              }
            }

            function i(e) {
              e.done ? n(e.value) : new l(function (n) {
                n(e.value);
              }).then(t, r);
            }

            i((c = c.apply(a, o || [])).next());
          });
        }(t, void 0, void 0, function () {
          return B(this, function (n) {
            switch (n.label) {
              case 0:
                return n.trys.push([0, 2,, 3]), j(!0), [4, o.media.persist([{
                  directory: u || "/",
                  file: e
                }])];

              case 1:
                return n.sent(), [3, 3];

              case 2:
                return n.sent(), [3, 3];

              case 3:
                return j(!1), [2];
            }
          });
        });
      }
    }),
        M = S.getRootProps,
        O = S.getInputProps,
        k = S.isDragActive,
        F = M(),
        z = F.onClick,
        I = L(F, ["onClick"]);

    return _.useEffect(function () {
      var n = null === document || void 0 === document ? void 0 : document.body;
      return n.style.overflow = "hidden", function () {
        n.style.overflow = "auto";
      };
    }, []), "loading" === c ? N.createElement(X, null) : "not-configured" === c ? N.createElement(J, {
      title: "Please Set up a Media Store"
    }) : "error" === c ? N.createElement(J, {
      title: "Failed to Load Media"
    }) : N.createElement(V, null, N.createElement(H, null, N.createElement(cn, {
      directory: u,
      setDirectory: f
    }), N.createElement(W, {
      onClick: z,
      uploading: C
    })), N.createElement(U, _T({}, I, {
      dragActive: k
    }), N.createElement("input", _T({}, O())), "loaded" === c && 0 === b.items.length && N.createElement($, null), b.items.map(function (n) {
      return N.createElement(K, {
        item: n,
        onClick: w,
        onSelect: E,
        onDelete: x
      });
    })), N.createElement(mn, {
      list: b,
      setOffset: g
    }));
  }

  var O,
      k,
      F,
      z,
      I,
      R,
      G,
      W = function W(n) {
    var e = n.onClick,
        t = n.uploading;
    return N.createElement(u.Button, {
      style: {
        minWidth: "5.3rem"
      },
      primary: !0,
      busy: t,
      onClick: e
    }, t ? N.createElement(r.LoadingDots, null) : "Upload");
  },
      X = h(function (n) {
    return N.createElement("div", _T({}, n), N.createElement(r.LoadingDots, {
      color: "var(--tina-color-primary)"
    }));
  }).withConfig({
    displayName: "LoadingMediaList",
    componentId: "sc-19uxp9l"
  })(O = O || v(["\n  width: 100%;\n  height: 75%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 100%;\n  height: 75%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])),
      V = h.div.withConfig({
    displayName: "MediaPickerWrap",
    componentId: "sc-fhqaq8"
  })(k = k || v(["\n  height: 100%;\n  overflow-y: auto;\n  color: var(--tina-color-grey-9);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  background-color: var(--tina-color-grey-1);\n  padding: 0 1rem var(--tina-padding-big) 1rem;\n\n  ::-webkit-scrollbar {\n    width: 0;\n  }\n\n  *:active,\n  *:focus {\n    outline: none;\n  }\n\n  @media (min-width: 720px) {\n    padding: 0 1.125rem var(--tina-padding-big) 1.125rem;\n  }\n"], ["\n  height: 100%;\n  overflow-y: auto;\n  color: var(--tina-color-grey-9);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  background-color: var(--tina-color-grey-1);\n  padding: 0 1rem var(--tina-padding-big) 1rem;\n\n  ::-webkit-scrollbar {\n    width: 0;\n  }\n\n  *:active,\n  *:focus {\n    outline: none;\n  }\n\n  @media (min-width: 720px) {\n    padding: 0 1.125rem var(--tina-padding-big) 1.125rem;\n  }\n"])),
      H = h.div.withConfig({
    displayName: "Header",
    componentId: "sc-1bzhq3l"
  })(F = F || v(["\n  display: flex;\n  align-items: center;\n  background: var(--tina-color-grey-1);\n  padding: var(--tina-padding-big) 0.75rem;\n  border-radius: var(--tina-radius-small);\n  position: sticky;\n  top: 0;\n  z-index: 1;\n\n  @media (min-width: 720px) {\n    padding: var(--tina-padding-big) 1rem var(--tina-padding-big) 1.125rem;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background: var(--tina-color-grey-1);\n  padding: var(--tina-padding-big) 0.75rem;\n  border-radius: var(--tina-radius-small);\n  position: sticky;\n  top: 0;\n  z-index: 1;\n\n  @media (min-width: 720px) {\n    padding: var(--tina-padding-big) 1rem var(--tina-padding-big) 1.125rem;\n  }\n"])),
      U = h.ul.withConfig({
    displayName: "List",
    componentId: "sc-19duo3y"
  })(I = I || v(["\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 2rem 0;\n  margin: 0;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 2rem 0;\n  margin: 0;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  ", "\n"]), function (n) {
    return n.dragActive && c.css(z = z || v(["\n      border: 2px solid var(--tina-color-primary);\n      border-radius: var(--tina-radius-small);\n    "], ["\n      border: 2px solid var(--tina-color-primary);\n      border-radius: var(--tina-radius-small);\n    "]));
  }),
      $ = h(function (n) {
    return N.createElement("div", _T({}, n), "Drag and Drop assets here");
  }).withConfig({
    displayName: "EmptyMediaList",
    componentId: "sc-1sa3wwo"
  })(R = R || v(["\n  font-size: 1.5rem;\n  opacity: 50%;\n  padding: 3rem;\n  text-align: center;\n"], ["\n  font-size: 1.5rem;\n  opacity: 50%;\n  padding: 3rem;\n  text-align: center;\n"])),
      J = h(function (n) {
    var e = n.title,
        t = L(n, ["title"]);
    return N.createElement("div", _T({}, t), N.createElement("h2", null, e), N.createElement("div", null, " ", "Visit the", " ", N.createElement("a", {
      href: "https://tinacms.org/docs/media",
      rel: "noreferrer noopener"
    }, "docs"), " ", "to learn more about setting up the Media Manager for your CMS."));
  }).withConfig({
    displayName: "DocsLink",
    componentId: "sc-klgsdz"
  })(G = G || v(["\n  height: 75%;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  a {\n    color: black;\n    text-decoration: underline;\n    font-weight: bold;\n  }\n"], ["\n  height: 75%;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  a {\n    color: black;\n    text-decoration: underline;\n    font-weight: bold;\n  }\n"]));

  function K(n) {
    var e = n.item,
        t = n.onClick,
        r = n.onSelect,
        i = n.onDelete;
    return N.createElement(rn, {
      onClick: function onClick() {
        return t(e);
      },
      type: e.type
    }, N.createElement(an, null, e.previewSrc ? N.createElement("img", {
      src: e.previewSrc,
      alt: e.filename
    }) : N.createElement(Q, {
      type: e.type
    })), N.createElement(on, null, e.filename), N.createElement(ln, null, r && "file" === e.type && N.createElement(u.Button, {
      small: !0,
      onClick: function onClick() {
        return r(e);
      }
    }, "Insert"), i && "file" === e.type && N.createElement(u.IconButton, {
      small: !0,
      onClick: function onClick() {
        return i(e);
      }
    }, N.createElement(o.TrashIcon, null))));
  }

  function Q(n) {
    return "dir" === n.type ? N.createElement(o.Folder, null) : N.createElement(o.File, null);
  }

  var Y,
      Z,
      nn,
      en,
      tn,
      rn = h.li.withConfig({
    displayName: "ListItem",
    componentId: "sc-1g1sx35"
  })(Z = Z || v(["\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  background-color: white;\n  filter: drop-shadow(0 0 0 transparent);\n  transition: filter 300ms ease;\n  border: 1px solid var(--tina-color-grey-2);\n  margin-bottom: var(--tina-padding-small);\n  border-radius: var(--tina-radius-small);\n  min-height: 90px;\n\n  > :first-child {\n    margin-right: var(--tina-padding-small);\n  }\n\n  &:hover {\n    filter: drop-shadow(var(--tina-shadow-small));\n    ", "\n  }\n\n  @media screen and (min-width: 720px) {\n    padding: 1.125rem;\n\n    > :first-child {\n      margin-right: var(--tina-padding-big);\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  background-color: white;\n  filter: drop-shadow(0 0 0 transparent);\n  transition: filter 300ms ease;\n  border: 1px solid var(--tina-color-grey-2);\n  margin-bottom: var(--tina-padding-small);\n  border-radius: var(--tina-radius-small);\n  min-height: 90px;\n\n  > :first-child {\n    margin-right: var(--tina-padding-small);\n  }\n\n  &:hover {\n    filter: drop-shadow(var(--tina-shadow-small));\n    ", "\n  }\n\n  @media screen and (min-width: 720px) {\n    padding: 1.125rem;\n\n    > :first-child {\n      margin-right: var(--tina-padding-big);\n    }\n  }\n"]), function (n) {
    return "dir" === n.type && c.css(Y = Y || v(["\n        cursor: pointer;\n      "], ["\n        cursor: pointer;\n      "]));
  }),
      an = h.div.withConfig({
    displayName: "ItemPreview",
    componentId: "sc-1sggd4s"
  })(nn = nn || v(["\n  width: 56px;\n  height: 56px;\n  border-radius: var(--tina-radius-small);\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  flex-shrink: 0;\n\n  > img {\n    object-fit: cover;\n    width: 100%;\n    min-height: 100%;\n    object-position: center;\n  }\n\n  > svg {\n    width: 47%;\n    height: 100%;\n    fill: var(--tina-color-grey-4);\n  }\n"], ["\n  width: 56px;\n  height: 56px;\n  border-radius: var(--tina-radius-small);\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  flex-shrink: 0;\n\n  > img {\n    object-fit: cover;\n    width: 100%;\n    min-height: 100%;\n    object-position: center;\n  }\n\n  > svg {\n    width: 47%;\n    height: 100%;\n    fill: var(--tina-color-grey-4);\n  }\n"])),
      on = h.span.withConfig({
    displayName: "Filename",
    componentId: "sc-1m8plc2"
  })(en = en || v(["\n  flex-grow: 1;\n  font-size: var(--tina-font-size-2);\n  overflow: hidden;\n  width: 100%;\n  overflow-wrap: break-word;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  flex-grow: 1;\n  font-size: var(--tina-font-size-2);\n  overflow: hidden;\n  width: 100%;\n  overflow-wrap: break-word;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])),
      ln = h.span.withConfig({
    displayName: "ActionButtons",
    componentId: "sc-lz1ywc"
  })(tn = tn || v(["\n  display: flex;\n  > * {\n    margin-left: var(--tina-padding-small);\n  }\n"], ["\n  display: flex;\n  > * {\n    margin-left: var(--tina-padding-small);\n  }\n"]));

  function cn(n) {
    var e = n.directory,
        t = void 0 === e ? "" : e,
        r = n.setDirectory,
        i = (t = t.replace(/^\/|\/$/g, "")).split("/");
    i.pop();
    var a = i.join("/");
    return N.createElement(fn, {
      showArrow: "" !== t
    }, N.createElement("span", {
      onClick: function onClick() {
        return r(a);
      }
    }, N.createElement(o.LeftArrowIcon, null)), N.createElement("button", {
      onClick: function onClick() {
        return r("");
      }
    }, "Media"), t && t.split("/").map(function (n, e, t) {
      return N.createElement("button", {
        onClick: function onClick() {
          r(t.slice(0, e + 1).join("/"));
        }
      }, n);
    }));
  }

  var sn,
      dn,
      un,
      fn = h.div.withConfig({
    displayName: "BreadcrumbWrapper",
    componentId: "sc-yg3jbq"
  })(un = un || v(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  color: var(--tina-color-grey-4);\n  font-size: var(--tina-font-size-3);\n  margin-left: -12px;\n\n  button {\n    text-transform: capitalize;\n    transition: color 180ms ease;\n    border: 0;\n    background-color: transparent;\n    font-size: inherit;\n    color: inherit;\n  }\n\n  > span {\n    display: flex;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n    fill: var(--tina-color-grey-4);\n    transform: translateX(6px);\n    opacity: 0;\n    transition: opacity 200ms ease, transform 300ms ease-out;\n    align-self: center;\n  }\n\n  ", "\n\n  svg:hover {\n    cursor: pointer;\n    fill: var(--tina-color-grey-9);\n  }\n\n  button:hover {\n    color: var(--tina-color-grey-9);\n  }\n\n  > :not(:last-child) {\n    display: none;\n  }\n\n  > :first-child {\n    display: inline;\n  }\n\n  *:not(span)::after {\n    content: '/';\n    padding-left: 8px;\n  }\n\n  > *:not(:first-of-type) {\n    padding-left: 8px;\n  }\n\n  @media (min-width: 720px) {\n    font-size: var(--tina-font-size-2);\n\n    svg {\n      margin-left: -8px;\n    }\n\n    ", "\n\n    > :not(:last-child) {\n      display: flex;\n    }\n\n    > *:not(:first-of-type) {\n      padding-left: 8px;\n    }\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  color: var(--tina-color-grey-4);\n  font-size: var(--tina-font-size-3);\n  margin-left: -12px;\n\n  button {\n    text-transform: capitalize;\n    transition: color 180ms ease;\n    border: 0;\n    background-color: transparent;\n    font-size: inherit;\n    color: inherit;\n  }\n\n  > span {\n    display: flex;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n    fill: var(--tina-color-grey-4);\n    transform: translateX(6px);\n    opacity: 0;\n    transition: opacity 200ms ease, transform 300ms ease-out;\n    align-self: center;\n  }\n\n  ", "\n\n  svg:hover {\n    cursor: pointer;\n    fill: var(--tina-color-grey-9);\n  }\n\n  button:hover {\n    color: var(--tina-color-grey-9);\n  }\n\n  > :not(:last-child) {\n    display: none;\n  }\n\n  > :first-child {\n    display: inline;\n  }\n\n  *:not(span)::after {\n    content: '/';\n    padding-left: 8px;\n  }\n\n  > *:not(:first-of-type) {\n    padding-left: 8px;\n  }\n\n  @media (min-width: 720px) {\n    font-size: var(--tina-font-size-2);\n\n    svg {\n      margin-left: -8px;\n    }\n\n    ", "\n\n    > :not(:last-child) {\n      display: flex;\n    }\n\n    > *:not(:first-of-type) {\n      padding-left: 8px;\n    }\n  }\n"]), function (n) {
    return n.showArrow && c.css(sn = sn || v(["\n      svg {\n        opacity: 1;\n        transform: translateX(0px);\n        transition: opacity 180ms ease, transform 300ms ease-in;\n      }\n    "], ["\n      svg {\n        opacity: 1;\n        transform: translateX(0px);\n        transition: opacity 180ms ease, transform 300ms ease-in;\n      }\n    "]));
  }, function (n) {
    return n.showArrow && c.css(dn = dn || v(["\n        svg {\n          transform: translateX(-4px);\n        }\n      "], ["\n        svg {\n          transform: translateX(-4px);\n        }\n      "]));
  });

  function mn(n) {
    var e = n.list,
        t = n.setOffset,
        r = e.limit || 10,
        i = Math.ceil(e.totalCount / r),
        a = (e.offset + r) / r,
        o = [];
    if (i <= 1) return null;

    for (var l = function l(n) {
      var e = n === a;
      o.push(N.createElement(xn, {
        active: e,
        onClick: function onClick() {
          return t(n * r);
        }
      }, n));
    }, c = 1; c <= i; c++) {
      l(c);
    }

    return N.createElement(wn, null, o);
  }

  var pn,
      gn,
      hn,
      yn,
      bn,
      vn,
      wn = h.div.withConfig({
    displayName: "PageLinksWrap",
    componentId: "sc-1fsg9a0"
  })(pn = pn || v(["\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n"])),
      xn = h.button.withConfig({
    displayName: "PageNumber",
    componentId: "sc-1th5cdk"
  })(hn = hn || v(["\n  padding: 0 0.15rem;\n  margin: var(--tina-padding-small);\n  transition: border 180ms ease;\n\n  ", "\n    :hover {\n    border-bottom: 1px solid var(--tina-color-grey-9);\n  }\n"], ["\n  padding: 0 0.15rem;\n  margin: var(--tina-padding-small);\n  transition: border 180ms ease;\n\n  ", "\n    :hover {\n    border-bottom: 1px solid var(--tina-color-grey-9);\n  }\n"]), function (n) {
    return !n.active && c.css(gn = gn || v(["\n        color: var(--tina-color-grey-4);\n      "], ["\n        color: var(--tina-color-grey-4);\n      "]));
  }),
      En = t.createScreen({
    name: "Media Manager",
    Component: M,
    Icon: o.MediaIcon,
    layout: "fullscreen",
    props: {
      allowDelete: !0
    }
  }),
      Pn = [i.TextFieldPlugin, i.TextareaFieldPlugin, i.ImageFieldPlugin, i.ColorFieldPlugin, i.NumberFieldPlugin, i.ToggleFieldPlugin, i.SelectFieldPlugin, i.GroupFieldPlugin, i.GroupListFieldPlugin, i.ListFieldPlugin, i.BlocksFieldPlugin, i.TagsFieldPlugin, E, P, x],
      Cn = (vn = n.CMS, _b(yn = Sn, bn = vn), void (yn.prototype = null === bn ? Object.create(bn) : (jn.prototype = bn.prototype, new jn())), Object.defineProperty(Sn.prototype, "alerts", {
    get: function get() {
      return this._alerts || (this._alerts = new l.Alerts(this.events)), this._alerts;
    },
    enumerable: !0,
    configurable: !0
  }), Sn.prototype.registerApi = function (n, e) {
    e.alerts && this.alerts.setMap(e.alerts), vn.prototype.registerApi.call(this, n, e);
  }, Object.defineProperty(Sn.prototype, "forms", {
    get: function get() {
      return this.plugins.findOrCreateMap("form");
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(Sn.prototype, "fields", {
    get: function get() {
      return this.plugins.findOrCreateMap("field");
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(Sn.prototype, "screens", {
    get: function get() {
      return this.plugins.findOrCreateMap("screen");
    },
    enumerable: !0,
    configurable: !0
  }), Sn);

  function jn() {
    this.constructor = yn;
  }

  function Sn(n) {
    void 0 === n && (n = {});
    var e = n.sidebar,
        t = n.toolbar,
        r = n.alerts,
        i = void 0 === r ? {} : r,
        a = L(n, ["sidebar", "toolbar", "alerts"]),
        o = vn.call(this, a) || this;

    if (o.alerts.setMap(_T({
      "media:upload:failure": function mediaUploadFailure() {
        return {
          level: "error",
          message: "Failed to upload file."
        };
      },
      "media:delete:failure": function mediaDeleteFailure() {
        return {
          level: "error",
          message: "Failed to delete file."
        };
      }
    }, i)), e) {
      var l = "object" == typeof e ? e : void 0;
      o.sidebar = new f.SidebarState(o.events, l);
    }

    if (t) {
      var c = "object" == typeof t ? t : void 0;
      o.toolbar = new m.ToolbarState(c);
    }

    return Pn.forEach(function (n) {
      o.fields.find(n.name) || o.fields.add(n);
    }), o.plugins.add(En), o;
  }

  function Mn(n) {
    var e = n.cms,
        t = n.children,
        r = n.position,
        i = n.styled,
        a = void 0 === i || i,
        o = _.useState(e.enabled),
        l = o[0],
        c = o[1];

    if (_.useEffect(function () {
      return e.events.subscribe("cms", function () {
        c(e.enabled);
      });
    }, []), !(e instanceof Cn)) throw new Error("The `cms` prop must be an instance of `TinaCMS`.");
    return _.createElement(d.CMSContext.Provider, {
      value: e
    }, _.createElement(s.ModalProvider, null, _.createElement(p.Alerts, {
      alerts: e.alerts
    }), l && a && _.createElement(u.Theme, null), l && e.toolbar && _.createElement(m.Toolbar, null), _.createElement(S, null), e.sidebar ? _.createElement(f.SidebarProvider, {
      position: r,
      sidebar: e.sidebar
    }, t) : t));
  }

  var On = Mn;
  Object.keys(s).forEach(function (n) {
    "default" !== n && Object.defineProperty(e, n, {
      enumerable: !0,
      get: function get() {
        return s[n];
      }
    });
  }), Object.keys(i).forEach(function (n) {
    "default" !== n && Object.defineProperty(e, n, {
      enumerable: !0,
      get: function get() {
        return i[n];
      }
    });
  }), Object.keys(a).forEach(function (n) {
    "default" !== n && Object.defineProperty(e, n, {
      enumerable: !0,
      get: function get() {
        return a[n];
      }
    });
  }), Object.defineProperty(e, "MediaManager", {
    enumerable: !0,
    get: function get() {
      return n.MediaManager;
    }
  }), Object.defineProperty(e, "ActionButton", {
    enumerable: !0,
    get: function get() {
      return r.ActionButton;
    }
  }), Object.defineProperty(e, "useScreenPlugin", {
    enumerable: !0,
    get: function get() {
      return t.useScreenPlugin;
    }
  }), Object.defineProperty(e, "CMSContext", {
    enumerable: !0,
    get: function get() {
      return d.CMSContext;
    }
  }), Object.defineProperty(e, "ERROR_MISSING_CMS", {
    enumerable: !0,
    get: function get() {
      return d.ERROR_MISSING_CMS;
    }
  }), Object.defineProperty(e, "useCMSEvent", {
    enumerable: !0,
    get: function get() {
      return d.useCMSEvent;
    }
  }), Object.defineProperty(e, "useForm", {
    enumerable: !0,
    get: function get() {
      return d.useForm;
    }
  }), Object.defineProperty(e, "useLocalForm", {
    enumerable: !0,
    get: function get() {
      return d.useLocalForm;
    }
  }), Object.defineProperty(e, "usePlugin", {
    enumerable: !0,
    get: function get() {
      return d.usePlugin;
    }
  }), Object.defineProperty(e, "usePlugins", {
    enumerable: !0,
    get: function get() {
      return d.usePlugins;
    }
  }), Object.defineProperty(e, "useSubscribable", {
    enumerable: !0,
    get: function get() {
      return d.useSubscribable;
    }
  }), Object.defineProperty(e, "useWatchFormValues", {
    enumerable: !0,
    get: function get() {
      return d.useWatchFormValues;
    }
  }), Object.defineProperty(e, "withPlugin", {
    enumerable: !0,
    get: function get() {
      return d.withPlugin;
    }
  }), Object.defineProperty(e, "withPlugins", {
    enumerable: !0,
    get: function get() {
      return d.withPlugins;
    }
  }), Object.defineProperty(e, "Form", {
    enumerable: !0,
    get: function get() {
      return g.Form;
    }
  }), e.GlobalFormPlugin = y, e.Tina = On, e.TinaCMS = Cn, e.TinaProvider = Mn, e.useCMS = A, e.useFormScreenPlugin = function (n) {
    var e = _.useMemo(function () {
      if (n) return new y(n);
    }, [n]);

    d.usePlugins(e);
  }, e.useGlobalForm = function (n, e) {
    void 0 === e && (e = {});

    var t = d.useForm(n, e),
        r = t[0],
        i = t[1],
        a = _.useMemo(function () {
      if (i) return new y(i);
    }, [i]);

    return d.usePlugins(a), [r, i];
  }, e.withTina = function (t, r) {
    return function (n) {
      var e = _.useMemo(function () {
        return new Cn(r);
      }, [r]);

      return _.createElement(Mn, {
        cms: e
      }, _.createElement(t, _T({}, n)));
    };
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});